import { render, staticRenderFns } from "./MAM_transferTerminalAgent.vue?vue&type=template&id=cba79d58&scoped=true&"
import script from "./MAM_transferTerminalAgent.vue?vue&type=script&lang=js&"
export * from "./MAM_transferTerminalAgent.vue?vue&type=script&lang=js&"
import style0 from "./MAM_transferTerminalAgent.vue?vue&type=style&index=0&id=cba79d58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba79d58",
  null
  
)

export default component.exports